import request from '@/axios'

export const getSystemConfigApi = (): Promise<IResponse> => {
  return request.get({ url: '/system/config' }).then((res) => {
    res.data.sale_tax_rate = Number(res.data.sale_tax_rate) / 100
    res.data.purchase_tax_rate = Number(res.data.purchase_tax_rate) / 100
    return res
  })
}

export const updateSystemConfigApi = (data: any): Promise<IResponse<null>> => {
  return request.post({ url: '/system/config', data })
}

export const initSystemDataApi = (data: any): Promise<IResponse<null>> => {
  return request.post({ url: '/system/init_data', data })
}

export const getStaffListApi = (params: any): Promise<IResponse> => {
  return request.get({ url: '/system/staff/list', params })
}

export const deleteStaffApi = (id: string): Promise<IResponse> => {
  return request.post({ url: `/system/staff/delete`, data: { id } })
}

export const setStaffApi = (data: any): Promise<IResponse> => {
  return request.post({ url: '/system/staff/set', data })
}

export const getSalesmanListApi = (params: any): Promise<IResponse> => {
  return request.get({ url: '/system/salesman/list', params })
}

export const deleteSalesmanApi = (id: string): Promise<IResponse> => {
  return request.post({ url: `/system/salesman/delete`, data: { id } })
}

export const setSalesmanApi = (data: any): Promise<IResponse> => {
  return request.post({ url: '/system/salesman/set', data })
}

export const getNoRuleListApi = (params: any): Promise<IResponse> => {
  return request.get({ url: '/system/order_no_rule/list', params })
}

export const updateNoRuleApi = (data: any): Promise<IResponse> => {
  return request.post({ url: '/system/order_no_rule/update', data })
}

export const getOperationLogListApi = (params: any): Promise<IResponse> => {
  return request.get({ url: '/system/operation_log/list', params })
}

export const deleteOperationLogApi = (): Promise<IResponse> => {
  return request.post({ url: `/system/operation_log/delete` })
}

export const getPrinterTemplateListApi = (params: any): Promise<IResponse> => {
  return request.get({ url: '/system/printer/template_list', params })
}

export const deletePrinterTemplateApi = (id: string): Promise<IResponse> => {
  return request.post({ url: `/system/printer/template_delete`, data: { id } })
}

export const setPrinterTemplateApi = (data: any): Promise<IResponse> => {
  return request.post({ url: '/system/printer/template_set', data })
}

export const GeneratePrinterTokenApi = (): Promise<IResponse> => {
  return request.post({ url: '/system/printer_token' })
}

export const setDefaultPrinterTemplateApi = (id: number): Promise<IResponse> => {
  return request.post({ url: '/system/printer/template_set_default', data: { id } })
}

export const getPrinterDataApi = (params: any): Promise<IResponse> => {
  return request.get({ url: '/system/printer/data', params })
}

export const getBackupListApi = (params: any): Promise<IResponse> => {
  return request.get({ url: '/system/backup/list', params })
}

export const manualBackupApi = (name: string, note: string): Promise<IResponse> => {
  return request.post({ url: '/system/backup/manual', data: { name, note } })
}

export const restoreBackupApi = (hash_id: string): Promise<IResponse> => {
  return request.post({ url: `/system/backup/restore`, data: { hash_id } })
}

export const deleteBackupApi = (hash_id: string): Promise<IResponse> => {
  return request.post({ url: `/system/backup/delete`, data: { hash_id } })
}

export const updatePasswordApi = (data: any): Promise<IResponse> => {
  return request.post({ url: '/system/update_password', data })
}

export const updateHeadImgApi = (data: any): Promise<IResponse> => {
  return request.post({ url: '/system/update_head_img', data })
}

export const getUserListApi = (params: any): Promise<IResponse> => {
  return request.get({ url: '/admin/user/list', params })
}

export const setUserApi = (data: any): Promise<IResponse> => {
  return request.post({ url: '/admin/user/set', data })
}

export const deleteUserApi = (id: number): Promise<IResponse> => {
  return request.post({ url: `/admin/user/delete`, data: { id } })
}

export const getGradePriceListApi = (params: any): Promise<IResponse> => {
  return request.get({ url: '/system/grade_price/list', params })
}

export const updateGradePriceApi = (data: any): Promise<IResponse> => {
  return request.post({ url: '/system/grade_price/update', data })
}

export const setTableColumnApi = (data: any): Promise<IResponse> => {
  return request.post({ url: '/system/table_column/set', data })
}
